/** Google Analytics 4 measurement ID */
export const GA_MEASUREMENT_ID = "G-S6699BKVLY";
